

    <div class="style vc-filter-mainHeading-container">
        <p class="vc-filter-mainHeading">{{ 'HISTORY-FILTER-DIALOG.TITLE' | translate }}</p>
    </div>

    <div class="flex-row">
        <label class="vc-filter-title">{{ 'VC-FILTER-DIALOG.DATE-RANGE' | translate }}</label>
    </div>

    <div class="group-margin">
        <div class="date-picker-group flex-row space-around-center gap-10">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'HISTORY-FILTER-DIALOG.START-DATE' | translate }}</mat-label>
                <input  readonly matInput   [matDatepicker]="picker1" [(ngModel)]="startDate"
                        (dateInput)="startDateChanged($event)" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>{{ 'HISTORY-FILTER-DIALOG.END-DATE' | translate }}</mat-label>
                <input  readonly matInput placeholder="" [matDatepicker]="picker2" [(ngModel)]="endDate"
                        (dateInput)="endDateChanged($event)" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <div class="vc-filter-container">
    <div class="flex-row">
        <label class="vc-filter-title">{{ 'VC-FILTER-DIALOG.TENANTS' | translate }}</label>
    </div>
    <div class="select-container">
        <button  class="select-btn" mat-button (click)="selectAll()">{{ 'VC-FILTER-DIALOG.SELECT-ALL' | translate }}</button>
        <button class="select-btn" mat-button (click)="selectNone()">{{ 'VC-FILTER-DIALOG.SELECT-NONE' | translate }}</button>
    </div>
    <div  class=" group-margin-vc filter-scrollable">
        <div *ngFor="let tenant of tenants; index as i">
            <mat-checkbox class="check-box" id="{{tenant.id}}" [(ngModel)]="tenants[i].isChecked">
                {{ tenant.name }}</mat-checkbox>
            <!-- <label>{{ i }} {{ tenants[i].isChecked }}</label> -->
        </div>

    </div>

    <div class="style buttons-container flex-row justify-end gap-10">
        <button class="cancel-vc-filter-btn" mat-flat-button type="button" (click)="closeDialog()">{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
        <button mat-flat-button class="filter-buttons" type="button" (click)="applyFilter()">{{ 'DATE-RANGE-DIALOG.APPLY' | translate }}</button>
    </div>


</div>

